const currencyFormat = (input: number, showCurrency = true) =>
  new Intl.NumberFormat(
    'ru-RU',
    showCurrency ? { style: 'currency', currency: 'RUB' } : undefined
  )
    .format(input)
    .replace(/,/g, '.');

export default currencyFormat;
